import { Action, createAction, handleActions } from "redux-actions";
import { queueMessage } from "~shared/snackbarsProvider/actions";
import {
  Dispatch,
  FechaFiltro,
  FiltroValue,
  GetState,
  ServicesReportesSiniestros,
  aFechaRequest,
} from "../../types";

export interface FiltrosSiniestrosState {
  take: FiltroValue;
  page: number;
  searchCriteria: string;
  estado: FiltroValue;
  tipo: FiltroValue | null;
  fechaDesde: FechaFiltro;
  fechaHasta: FechaFiltro;
  buttonDescargaEnabled: boolean;
  buttonDescargaText: string;
  errorMessage?: string;
}

/** Los filtros que viajan al reporte, tal como los tiene la pantalla. */
export interface FiltrosReporteSiniestros {
  searchCriteria: string;
  estado: FiltroValue;
  tipo: FiltroValue | null;
  fechaDesde: FechaFiltro;
  fechaHasta: FechaFiltro;
}

/** Error del backend: ServiceStack devuelve el detalle en `responseStatus`. */
interface ErrorApi {
  responseStatus: { message: string };
}

const setInitialStateSiniestros = createAction(
  "SET_INITIAL_STATE_FILTRO_SINIESTROS"
);

const selectSearchCriteria = createAction(
  "SELECT_SEARCH_CRITERIA_SINIESTROS",
  (searchCriteria: string) => ({
    searchCriteria,
  })
);

const descargaInited = createAction(
  "GET_REPORTE_SINIESTROS_INITED",
  (data: FiltrosReporteSiniestros) => ({ data })
);
const descargaCompleted = createAction("GET_REPORTE_SINIESTROS_COMPLETED");
const descargaFailed = createAction(
  "GET_REPORTE_SINIESTROS_FAILED",
  (error: ErrorApi) => ({ error })
);

const selectEstado = createAction(
  "SELECT_ESTADO_SINIESTROS",
  (estado: FiltroValue) => ({
    estado,
  })
);

const selectTipo = createAction(
  "SELECT_TIPO_SINIESTROS",
  (tipo: FiltroValue | null) => ({
    tipo,
  })
);

const setPage = createAction("SET_LISTADO_SINIESTROS_PAGE", (page: number) => ({
  page,
}));

const setTake = createAction(
  "SET_LISTADO_SINIESTROS_ROWS_PER_PAGE",
  (take: FiltroValue) => ({
    take,
  })
);

const clearData = createAction("CLEAR_DATA_FILTRO_SINIESTROS", () => ({}));

const selectFechaDesde = createAction(
  "SELECT_FECHA_DESDE_FILTRO",
  (fechaDesde: FechaFiltro) => ({ fechaDesde })
);

const selectFechaHasta = createAction(
  "SELECT_FECHA_HASTA_FILTRO",
  (fechaHasta: FechaFiltro) => ({ fechaHasta })
);

const listadoSiniestrosFiltroReducerInitialState: FiltrosSiniestrosState = {
  take: 10,
  page: 0,
  searchCriteria: "",
  estado: "Ingresado",
  tipo: "",
  fechaDesde: "",
  fechaHasta: "",
  buttonDescargaEnabled: true,
  buttonDescargaText: "DESCARGAR REPORTE",
};

const listadoSiniestrosFiltroReducer = handleActions<
  FiltrosSiniestrosState,
  any
>(
  {
    [setInitialStateSiniestros.toString()]: (): FiltrosSiniestrosState => {
      return {
        ...listadoSiniestrosFiltroReducerInitialState,
      };
    },
    [selectSearchCriteria.toString()]: (
      state: FiltrosSiniestrosState,
      action: Action<{ searchCriteria: string }>
    ): FiltrosSiniestrosState => {
      return {
        ...state,
        searchCriteria: action.payload.searchCriteria,
      };
    },
    [setTake.toString()]: (
      state: FiltrosSiniestrosState,
      action: Action<{ take: FiltroValue }>
    ): FiltrosSiniestrosState => {
      return {
        ...state,
        take: action.payload.take,
      };
    },
    [setPage.toString()]: (
      state: FiltrosSiniestrosState,
      action: Action<{ page: number }>
    ): FiltrosSiniestrosState => {
      return {
        ...state,
        page: action.payload.page,
      };
    },
    [selectEstado.toString()]: (
      state: FiltrosSiniestrosState,
      action: Action<{ estado: FiltroValue }>
    ): FiltrosSiniestrosState => {
      return {
        ...state,
        estado: action.payload.estado,
      };
    },
    [selectTipo.toString()]: (
      state: FiltrosSiniestrosState,
      action: Action<{ tipo: FiltroValue | null }>
    ): FiltrosSiniestrosState => {
      return {
        ...state,
        tipo: action.payload.tipo,
      };
    },
    [selectFechaDesde.toString()]: (
      state: FiltrosSiniestrosState,
      action: Action<{ fechaDesde: FechaFiltro }>
    ): FiltrosSiniestrosState => {
      return {
        ...state,
        fechaDesde: action.payload.fechaDesde,
      };
    },
    [selectFechaHasta.toString()]: (
      state: FiltrosSiniestrosState,
      action: Action<{ fechaHasta: FechaFiltro }>
    ): FiltrosSiniestrosState => {
      return {
        ...state,
        fechaHasta: action.payload.fechaHasta,
      };
    },
    [descargaInited.toString()]: (
      state: FiltrosSiniestrosState
    ): FiltrosSiniestrosState => {
      return {
        ...state,
        buttonDescargaEnabled: false,
        buttonDescargaText: "DESCARGANDO...",
      };
    },
    [descargaCompleted.toString()]: (
      state: FiltrosSiniestrosState
    ): FiltrosSiniestrosState => {
      return {
        ...state,
        buttonDescargaEnabled: true,
        buttonDescargaText: "DESCARGAR REPORTE",
      };
    },
    [descargaFailed.toString()]: (
      state: FiltrosSiniestrosState,
      action: Action<{ error: ErrorApi }>
    ): FiltrosSiniestrosState => {
      return {
        ...state,
        errorMessage: action.payload.error.responseStatus.message,
        buttonDescargaEnabled: true,
        buttonDescargaText: "DESCARGAR REPORTE",
      };
    },
    [clearData.toString()]: (): FiltrosSiniestrosState => {
      return {
        ...listadoSiniestrosFiltroReducerInitialState,
      };
    },
  },
  listadoSiniestrosFiltroReducerInitialState
);

const descargarReporte = (data: FiltrosReporteSiniestros) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesReportesSiniestros
  ) => {
    try {
      dispatch(descargaInited(data));
      let response = await services.api.reportes().getSiniestros({
        searchCriteria: data.searchCriteria,
        estado: String(data.estado),
        tipo: data.tipo ? String(data.tipo) : undefined,
        fechaDesde: aFechaRequest(data.fechaDesde),
        fechaHasta: aFechaRequest(data.fechaHasta),
      });

      // create a fake anchor and click it programatically to
      // force the file to download
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          var downloadUrl = URL.createObjectURL(xhttp.response);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style.cssText = "display: none";
          a.href = downloadUrl;
          a.download = "";
          a.click();
        }
      };

      xhttp.open("GET", response.url, true);
      xhttp.responseType = "blob";
      xhttp.send();

      dispatch(descargaCompleted());
    } catch (error) {
      console.error(error);
      dispatch(descargaFailed(error as ErrorApi));
      dispatch(
        queueMessage(
          "Ocurrió un error al descargar el reporte. Intente nuevamente."
        )
      );
    }
  };
};

export { listadoSiniestrosFiltroReducer };

export {
  setTake,
  setPage,
  clearData,
  selectSearchCriteria,
  selectEstado,
  selectTipo,
  setInitialStateSiniestros,
  selectFechaDesde,
  selectFechaHasta,
  descargarReporte,
};
